<template>
  <v-container class="content-selector" fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>

            <v-btn
              v-if="env !== 'production'"
              @click="dialogCreated = true"
              dark
              fixed
              bottom
              color="pink"
              right
              fab
              style="margin-bottom: 50px; margin-right: 10px;"
            >
              <v-icon>add</v-icon>
            </v-btn>


            <v-navigation-drawer
              persistent
              :mini-variant="miniVariant"
              :clipped="clipped"
              v-model="drawer"
              enable-resize-watcher
              fixed
              app
            >
              <v-list>
                <v-list-tile
                  value="true"
                  v-for="(item, i) in items"
                  :key="i"
                >
                  <v-list-tile-action>
                    <v-icon v-html="item.icon"></v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.title"></v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>

            <v-toolbar :color="this.getTheme.color" dark>
              <!-- <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon> -->
              <v-toolbar-title style="cursor: pointer;"><span @click="schedule()">{{ date | formatDate(date) }}</span> | <span @click="dialogSelectCRM = true">CRM: {{auth.auth.myClinic.crm}}</span></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="schedule()">
                <v-icon>event</v-icon>
              </v-btn>

              <!-- <v-menu bottom left>
                <v-btn icon slot="activator">
                  <v-icon v-if="env !== 'production'">view_module</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile v-for="item in menuItems" :key="item.title" style="cursor: pointer;">
                    <v-list-tile-action>
                    <v-icon v-html="item.icon"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-text="item.title" :to="item.to" @click.prevent="actionMenu(item.action)"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu> -->

              <!-- <v-btn icon>
                <v-icon>view_module</v-icon>
              </v-btn> -->
            </v-toolbar>
            <v-list three-line subheader>
              <v-subheader inset>Compromissos</v-subheader>
              <v-list-tile v-for="item in items" :key="item.title" avatar @click="">
                <v-list-tile-avatar>
                  <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>Tipo: {{ detailSchedule.typeDesc || detailSchedule.typeAppontement }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn @click="infoSchedule()" icon ripple>
                    <v-icon color="grey lighten-1">info</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-subheader inset @click="schedule()" style="cursor: pointer;">Horários - Clinic</v-subheader>
              <v-list-tile v-for="item in items2" :key="item.subtitle" avatar @click="">
                <v-list-tile-avatar>
                  <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>Tipo: {{ item.type }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title v-if="item.typeAppontement">Tipo Agend.: {{ item.typeAppontement }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <!-- <v-list-tile-action>
                  <v-btn @click="infoSchedule(item)" icon ripple>
                    <v-icon color="grey lighten-1">360</v-icon>
                  </v-btn>
                </v-list-tile-action> -->
                <v-list-tile-action>
                  <v-btn @click="infoSchedule(item)" icon ripple>
                    <v-icon color="grey lighten-1">info</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-subheader inset @click="schedule()" style="cursor: pointer;">Horários - Centro Cirúrgico</v-subheader>

              <v-list-tile v-for="item in items3" :key="item.subtitle" avatar @click="">
                <v-list-tile-avatar>
                  <v-icon :class="[item.iconClass]">{{ item.icon }}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.subtitle }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>Tipo: {{ item.type }}</v-list-tile-sub-title>
                </v-list-tile-content>
                <!-- <v-list-tile-action>
                  <v-btn @click="infoSchedule(item)" icon ripple>
                    <v-icon color="grey lighten-1">360</v-icon>
                  </v-btn>
                </v-list-tile-action> -->
                <v-list-tile-action>
                  <v-btn @click="infoSchedule(item)" icon ripple>
                    <v-icon color="grey lighten-1">info</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-card>

          <v-card v-show="getList.length">
            <chart-agreement></chart-agreement>
          </v-card>

          <v-card v-show="getList.length">
            <chart-type></chart-type>
          </v-card>

        </v-flex>
      </v-layout>
    </v-slide-y-transition>

    <v-dialog
      v-model="infoScheduleModal"
      :fullscreen="getDevice.isMobile"
      :hide-overlay="getDevice.isMobile"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeModalInfo()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Dados</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="closeModalInfo()">Sair</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-layout row>
          <v-flex xs12 sm12>

            <v-tabs
              centered
              :color="this.getTheme.color"
              dark
              icons-and-text
            >
              <v-tabs-slider color="yellow"></v-tabs-slider>

              <v-tab href="#tab-1" @click="getListRecordItem(detailSchedule.code)">
                Perfil
                <v-icon>account_box</v-icon>
              </v-tab>

              <v-tab href="#tab-2" @click="getListRecordItem(detailSchedule.code)">
                Prontuário
                <v-icon>favorite</v-icon>
              </v-tab>

              <v-tab target="_blank" :href="'https://telemedicina.gestaoclinic.com.br/?token=' + auth.auth.user.crm + '&idExterno=' + detailSchedule.code">
                Telemedicina
                <v-icon>duo</v-icon>
              </v-tab>

              <!-- <v-tab target="_blank" :href="'https://memed.gestaoclinic.com.br/?token=' + urlDataToken + '&idExterno=' + detailSchedule.code + '&idCustomer=' + auth.auth.user.codeCustomer + '&idReceituario=1&idDoctor=' + auth.auth.user.crm">
                Memed-Receituário
                <v-icon>description</v-icon>
              </v-tab> -->
              <v-tab-item
                :key="1"
                :value="'tab-1'"
              >
            <v-card>
              <v-img
                src="https://cdn.onlinewebfonts.com/svg/img_568657.png"
                height="350px"
              >
                <v-layout
                  column
                  fill-height
                >
                  <v-card-title>
                    <!-- <v-btn dark icon>
                      <v-icon>chevron_left</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn dark icon class="mr-3">
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn dark icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn> -->
                  </v-card-title>

                  <v-spacer></v-spacer>

                  <v-card-title class="white--text pl-5 pt-5">
                    <div class="display-1 pl-5 pt-5">{{detailSchedule.title}}</div>
                  </v-card-title>
                </v-layout>
              </v-img>

              <v-list two-line>
                <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-icon :color="this.getTheme.color">phone</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title><a :href="'tel:' + detailSchedule.mobile">{{detailSchedule.mobile}}</a></v-list-tile-title>
                    <v-list-tile-sub-title>Celular</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <a :href="'sms:' + detailSchedule.mobile">
                      <v-icon>chat</v-icon>
                    </a>
                  </v-list-tile-action>
                </v-list-tile>


                <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-icon :color="this.getTheme.color">phone</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title><a :href="'tel:' + detailSchedule.mobile">{{detailSchedule.mobile}}</a></v-list-tile-title>
                    <v-list-tile-sub-title>Celular</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <a target="_blank" :href="'https://wa.me/' + detailSchedule.mobile + '?text=Link para acessar Telemedicina'">
                      <i class="fab fa-whatsapp fa-lg"></i>
                    </a>
                  </v-list-tile-action>
                </v-list-tile>

                <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-icon :color="this.getTheme.color">bookmark</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>{{detailSchedule.typeDesc || detailSchedule.typeAppontement}}</v-list-tile-title>
                    <v-list-tile-sub-title>Tipo Agendamento</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <!-- <v-list-tile-action>
                    <v-icon>chat</v-icon>
                  </v-list-tile-action> -->
                </v-list-tile>

                <v-divider inset></v-divider>

                <!-- <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-icon :color="this.getTheme.color">mail</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>{{detailSchedule.convenant}}</v-list-tile-title>
                    <v-list-tile-sub-title>Personal</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile> -->

                <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-icon :color="this.getTheme.color">mail</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>{{detailSchedule.email || 'nao@informado.com'}}</v-list-tile-title>
                    <v-list-tile-sub-title>E-Mail</v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <a :href="'mailto:' + detailSchedule.email">
                      <v-icon>mail</v-icon>
                    </a>
                  </v-list-tile-action>
                </v-list-tile>

                <v-divider inset></v-divider>

                <v-list-tile @click="">
                  <v-list-tile-action>
                    <v-icon :color="this.getTheme.color">local_hospital</v-icon>
                  </v-list-tile-action>

                  <v-list-tile-content>
                    <v-list-tile-title>Convênio</v-list-tile-title>
                    <v-list-tile-sub-title>{{detailSchedule.convenantDesc}}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>

            </v-card>
              </v-tab-item>

              <v-tab-item
                :key="2"
                :value="'tab-2'"
              >
                <v-btn
                  absolute
                  top
                  color="pink"
                  right
                  fab
                  @click="newRecord = true"
                  class="btn-record"
                  v-show="!newRecord"
                >
                  <v-icon>add</v-icon>
                </v-btn>

                <div v-show="newRecord">
                  <new-record @close="closeNewRecord()"></new-record>
                </div>

                <div v-show="!newRecord">
                  <v-timeline v-if="!getDevice.isMobile">
                    <v-timeline-item
                      v-for="(item, i) in itensRecord"
                      :key="i"
                      :color="item.color"
                      small
                    >
                      <template v-slot:opposite>
                        <span
                          :class="`headline font-weight-bold ${item.color}--text`"
                          v-text="item.date"
                        ></span>
                      </template>
                      <div class="py-4">
                        <h2 :class="`headline font-weight-light mb-4 ${item.color}--text`">{{item.doctor}}</h2>
                        <div>
                          {{item.history}}
                        </div>
                      </div>
                    </v-timeline-item>
                  </v-timeline>

                  <v-timeline
                    align-top
                    dense
                    v-for="(item, i) in itensRecord"
                    :key="i"
                    v-show="getDevice.isMobile"
                  >
                    <v-timeline-item
                      color="pink"
                      small
                    >
                      <v-layout pt-3>
                        <v-flex xs3>
                          <strong>{{item.date}}</strong>
                        </v-flex>
                        <v-flex>
                          <strong>{{item.doctor}}</strong>
                          <div class="caption">{{item.history}}</div>
                        </v-flex>
                      </v-layout>
                    </v-timeline-item>
                  </v-timeline>
                </div>
              </v-tab-item>

              <v-tab-item
                :key="3"
                :value="'tab-3'"
              >
                <!-- <vue-jitsi-meet
                  ref="jitsiRef"
                  domain="meet.jit.si"
                  :options="jitsiOptions"
                ></vue-jitsi-meet> -->
              </v-tab-item>
            </v-tabs>
          </v-flex>
        </v-layout>

        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn
            :color="this.getTheme.color"
            flat
            @click="getListRecordItem(detailSchedule.code)"
          >
            Prontuário
          </v-btn> -->
          <v-btn
            color="info"
            flat
            @click="closeModalInfo()"
          >
            Sair
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="infoScheduleModalFree"
      :fullscreen="getDevice.isMobile"
      :hide-overlay="getDevice.isMobile"
    >
        <v-toolbar dark color="primary">
        <v-btn icon dark @click="infoScheduleModalFree = false">
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Dados</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark flat @click="infoScheduleModalFree = false">Sair</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card>

        <v-layout row>
          <v-flex xs12 sm12>
            <v-card>
              <v-img
                src="https://cdn.onlinewebfonts.com/svg/img_568657.png"
                height="350px"
              >
                <v-layout
                  column
                  fill-height
                >
                  <v-card-title>
                    <!-- <v-btn dark icon>
                      <v-icon>chevron_left</v-icon>
                    </v-btn>

                    <v-spacer></v-spacer>

                    <v-btn dark icon class="mr-3">
                      <v-icon>edit</v-icon>
                    </v-btn>

                    <v-btn dark icon>
                      <v-icon>more_vert</v-icon>
                    </v-btn> -->
                  </v-card-title>

                  <v-spacer></v-spacer>

                  <v-card-title class="white--text pl-5 pt-5">
                    <div class="display-1 pl-5 pt-5">{{detailSchedule.title}}</div>
                  </v-card-title>
                </v-layout>
              </v-img>

              <v-card-title class="headline">{{this.detailTypeAppontament.title}}</v-card-title>
              <v-card-text>{{this.detailTypeAppontament.desc}}</v-card-text>
              <v-spacer></v-spacer>

            </v-card>
          </v-flex>
        </v-layout>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="orange"
            @click="blockAppontament(detailSchedule)"
          >
            {{this.detailTypeAppontament.buttonOk}}
          </v-btn>
          <v-btn
            color="info"
            @click="infoScheduleModalFree = false"
          >
            Sair
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      ref="dialog"
      v-model="modal"
      :return-value.sync="date"
      persistent
      lazy
      full-width
      width="290px"
    >
      <v-date-picker
        v-model="date"
        scrollable
        locale="pt-br"
        :color="this.getTheme.color"
        :events="functionEvents"
      >
        <v-spacer></v-spacer>
        <v-btn flat :color="this.getTheme.color" @click="modal = false">Cancelar</v-btn>
        <!-- <v-btn flat color="primary" @click="$refs.dialog.save(date)">OK</v-btn> -->
        <v-btn flat :color="this.getTheme.color" @click="appointments(date)">OK</v-btn>
      </v-date-picker>
    </v-dialog>

    <div class="text-center">
      <v-dialog
        v-model="dialogSelectCRM"
      >
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title
          >
            Selecione a agenda que vai visualizar
          </v-card-title>

          <v-card-text>
            <change-schedule />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="dialogSelectCRM = false"
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

    <div class="text-center">
      <v-dialog v-model="dialogCreated" fullscreen hide-overlay transition="dialog-bottom-transition">
        <create-schedule />
      </v-dialog>
    </div>

  </v-container>
</template>

<script>
  import moment from 'moment'
  // import { v4 as uuidv4 } from 'uuid'
  // import { JitsiMeet } from '@mycure/vue-jitsi-meet'
  import ChartAgreement from '../../components/charts/schedule/AgreementColumn'
  import ChartType from '../../components/charts/schedule/Type'
  import NewRecord from '../../components/patient/record/new'
  import ChangeSchedule from '../../components/schedule/change'
  import CreateSchedule from '../../components/schedule/create'
  import { mapActions, mapGetters } from 'vuex'
  export default {
    components: {
      ChartAgreement,
      ChartType,
      NewRecord,
      ChangeSchedule,
      CreateSchedule
      // VueJitsiMeet: JitsiMeet
    },
    computed: {
      // jitsiOptions () {
      //   return {
      //     roomName: uuidv4(),
      //     noSSL: false,
      //     userInfo: {
      //       email: 'contato@spitzer.io',
      //       displayName: 'Spitzer'
      //     },
      //     height: 500,
      //     configOverwrite: {
      //       disableDeepLinking: true, // isso faz abrir direto sem chamar o app
      //       enableNoisyMicDetection: false
      //     },
      //     interfaceConfigOverwrite: {
      //       SHOW_JITSI_WATERMARK: false,
      //       SHOW_WATERMARK_FOR_GUESTS: false,
      //       SHOW_CHROME_EXTENSION_BANNER: false
      //     },
      //     onload: this.onIFrameLoad
      //   }
      // },
      ...mapGetters({
        customer: 'customer',
        auth: 'auth'
      }),
      ...mapGetters('medicalRecord', ['getListRecord', 'getAvailableAppointments']),
      ...mapGetters('memed', ['getToken']),
      ...mapGetters('schedule', ['getList', 'getAvailableAppointments', 'getAppointments', 'getAppointmentsSurgerycenter']),
      ...mapGetters('app', ['getTheme', 'getDevice'])
    },
    methods: {
      // onIFrameLoad () {
      //   this.$refs.jitsiRef.executeCommand('displayName', this.auth.auth.user.name)
      // },
      ...mapActions('medicalRecord', ['setListRecord', 'setAvailableAppointments']),
      ...mapActions('schedule', ['setList', 'setAvailableAppointments', 'setLockAppointments', 'setUnLockAppointments', 'setAppointmentsSurgerycenter', 'setSurgeries']),
      ...mapActions('patient', ['setPatient']),
      ...mapActions('memed', ['createPatientMemed']),
      setDialogSelectCRM () {
        this.appointments(this.date, this.auth.auth.myClinic.crm)
        this.dialogSelectCRM = false
      },
      functionEvents (date) {
        // const [,, day] = date.split('-')
        // if ([12, 17, 28].includes(parseInt(day, 10))) return true
        // if ([1, 19, 22].includes(parseInt(day, 10))) return ['red', '#00f']
        return false
      },
      getListRecordItem (item) {
        this.setListRecord({ patient: item, customer: this.auth.auth.myClinic.customer }).then(() => {
          this.itensRecord = this.getListRecord
        })
      },
      blockAppontament (item) {
        this.infoScheduleModalFree = false
        if (this.detailTypeAppontament.title === 'Horário Vago') {
          this.setLockAppointments(item).then(() => {
            const period = moment(item.period, 'MM/DD/YYYY').format('YYYY-MM-DD')
            this.appointments(period)
          })
        } else {
          this.setUnLockAppointments(item).then(() => {
            const period = moment(item.period, 'MM/DD/YYYY').format('YYYY-MM-DD')
            this.appointments(period)
          })
        }
      },
      infoSchedule (item) {
        if ((item.id === undefined) || (item.id === null)) {
          this.infoScheduleModalFree = true
          this.detailTypeAppontament.title = 'Horário Vago'
          this.detailTypeAppontament.desc = 'Deseja Bloquear este horário?'
          this.detailTypeAppontament.buttonOk = 'Bloquear'
          this.detailSchedule = item
        } else if (item.type === 'Horário Bloqueado') {
          this.detailTypeAppontament.title = 'Horário Bloqueado'
          this.detailTypeAppontament.desc = 'Deseja Desbloquear o horário?'
          this.detailTypeAppontament.buttonOk = 'Desbloquear'
          this.infoScheduleModalFree = true
          this.detailSchedule = item
        } else {
          this.getListRecordItem(item.code)
          this.infoScheduleModal = true
          this.detailSchedule = item
          this.setPatient(item.code)
          item.idCustomer = this.auth.auth.myClinic.customer
          this.createPatientMemed(item)
        }
      },
      closeNewRecord () {
        this.newRecord = false
      },
      schedule () {
        this.modal = true
      },
      closeModalInfo () {
        this.infoScheduleModal = false
        this.newRecord = false
      },
      closeDialogCreate () {
        this.dialogCreated = false
      },
      appointments (date) {
        this.modal = false
        const period = moment(date).format('YYYY-MM-DD')
        this.loading = true
        this.setList({ date: period, doctor: this.auth.auth.myClinic.crm, customer: this.auth.auth.myClinic.customer }).then(() => {
          this.items = this.getAppointments
          this.items2 = this.getList
          this.loading = false
          this.date = date
          this.urlDataToken = this.getToken
        })

        this.setAppointmentsSurgerycenter({ date: period, doctor: this.auth.auth.myClinic.crm }).then(() => {
          this.items3 = this.getAppointmentsSurgerycenter
        }).catch((err) => {
          console.error(err)
          this.items3 = []
        })
      },
      actionMenu (value) {
        if (value === 'proposed-surgeries') {
          this.$router.push('/proposed-surgeries')
        } else if (value === 'change-schedule') {
          this.$router.push('/change-schedule')
        } else if (value === 'change-schedule') {
          this.$router.push('/change-schedule')
        }
      }
    },
    mounted () {
      this.$bus.$on('setDialogSelectCRM', this.setDialogSelectCRM)
      this.$bus.$on('closeDialogSchedule', this.closeDialogCreate)
      this.appointments(new Date().toISOString().substr(0, 10), this.auth.auth.myClinic.crm)
      this.env = process.env.NODE_ENV
      this.setSurgeries()
    },
    filters: {
      formatDate: (value) => {
        if (!value) return ''
        return moment(value).format('DD-MM-YYYY')
      }
    },
    data () {
      return {
        env: null,
        menuItems: [
          { title: 'Clinic', to: '/change-schedule', icon: 'event', action: 'proposed-surgeries' },
          { title: 'Centro Cirurgico', to: '/profile', icon: 'mdi-hospital-box', action: 'change-schedule' },
          { title: 'Compromissos', to: '/auth/login', icon: 'notifications', action: 'change-schedule' }
        ],
        urlDataToken: null,
        detailSchedule: {},
        detailTypeAppontament: {},
        infoScheduleModal: false,
        infoScheduleModalFree: false,
        dialogSelectCRM: false,
        dialogCreated: false,
        loading: false,
        miniVariant: true,
        clipped: true,
        drawer: false,
        fixed: false,
        modal: false,
        date: new Date().toISOString().substr(0, 10),
        items: [],
        items2: [],
        items3: [],
        itensRecord: [],
        newRecord: false
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/schedule/index.vue